import { useRoutes, type GetJewelleriesRouteParam } from '@/router/routes'
import type { JewelleriesRedirectProducTypeProps } from './JewelleriesRedirectProductType.vue'
import { useRedirect } from 'wucdbm-vite-vue-ssr'
import { useRouter } from 'vue-router'

export function useLegacyJewelleryRedirect(
    props: JewelleriesRedirectProducTypeProps
): () => Promise<void> {
    const redirect = useRedirect()
    const routes = useRoutes()
    const router = useRouter()

    return async () => {
        // routes with more than one gemstone should redirect to the
        // main jewellery page
        const route: GetJewelleriesRouteParam | undefined =
            props.legacyGemstones && props.legacyGemstones.length > 1
                ? undefined
                : {
                      productType: props.productType,
                      productStyle: props.productStyle,
                      designStyle: props.designStyle,
                      page: props.page,
                      priceMin: props.priceMin,
                      priceMax: props.priceMax,
                      designFeatures:
                          props.legacyDesignFeatures || props.designFeatures,
                      gemstone: props.legacyGemstones?.[0],
                      metal: props.metal?.[0],
                  }

        await redirect(router.resolve(routes.jewelleries(route)).href, 301)
    }
}
